//Get Session Konseling

import axios from "axios";
import {
  GET_SESSION_KONSELING_FAIL,
  GET_SESSION_KONSELING_REQUEST,
  GET_SESSION_KONSELING_RESET,
  GET_SESSION_KONSELING_STATUS_FAIL,
  GET_SESSION_KONSELING_STATUS_REQUEST,
  GET_SESSION_KONSELING_STATUS_RESET,
  GET_SESSION_KONSELING_STATUS_SUCCESS,
  GET_SESSION_KONSELING_SUCCESS,
  PDULI_ALERT_TIME_WILL_BE_OVER,
  STOP_SESSION_KONSELING_FAIL,
  STOP_SESSION_KONSELING_REQUEST,
  STOP_SESSION_KONSELING_RESET,
  STOP_SESSION_KONSELING_SUCCESS,
} from "../constants/SessionKonselingConstants";
import {
  DUMMY_PDULI_SESSION_DATA_2,
  DUMMY_PDULI_SESSION_DATA_STAUTS,
} from "../dummy/konseling_dummy";
import { KONSELOR_INFO_DUMMY } from "../dummy/konselor_dummy";
import { UserDatPduliaDecode } from "../function/base64Function";
import {
  API_GET_SESSION_KONSELING,
  API_STOP_SESSION_KONSELING,
} from "../init/urlApi";

export const RGetSessionKonseling = () => async (dispatch) => {
  dispatch({
    type: GET_SESSION_KONSELING_RESET,
  });
};

export const GetSessionKonseling = () => async (dispatch) => {
  //   const { token, session } = userDataLocalStorage();
  const { token, typeUser, session } = UserDatPduliaDecode();
  try {
    dispatch({
      type: GET_SESSION_KONSELING_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    };

    const { data: data } = await axios.get(
      API_GET_SESSION_KONSELING(session, typeUser),
      config
    );

    // let data = DUMMY_PDULI_SESSION_DATA_2;
    // console.log(
    //   "data send api pduli GetKonselingSession dummy",
    //   DUMMY_PDULI_SESSION_DATA_2
    // );

    let objTmp = {};
    objTmp.voucher = {
      code: null,
      name: null,
      by: null,
      description: null,
      problem: data.data.problems,
    };
    objTmp.session = {
      date: data.data.session_date,
      startTime: data.data.start_time,
      duration: data.data.duration,
      // date: "2024-08-09T00:00:00.000Z",
      // startTime: "08:48:00",
      // duration: 60,
      status: data.data.status,
    };
    objTmp.result = {
      suggestion: data.data.suggestion,
      conclusion: data.data.conclusion,
    };
    objTmp.agora = {
      idKonseli: 1,
      idKonselor: 2,
    };
    objTmp.konseli = {
      name: data.data.conseleeName,
      dateOfBirth: null,
      address: null,
      gender: data.data.conseleeGender,
      photo: data.data.conseleeProfilePicture,
    };
    objTmp.konselor = {
      name: data.data.conselorName,
      dateOfBirth: null,
      address: null,
      gender: data.data.conselorGender,
      photo: data.data.conselorProfilePicture,
    };
    let lk = null;
    if (data.data?.linkTM != null && data.data?.linkTM != undefined) {
      lk = data.data?.linkTM + "?view=true";
    }
    objTmp.dokumen = lk;
    dispatch({
      type: GET_SESSION_KONSELING_SUCCESS,
      payload: objTmp,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: GET_SESSION_KONSELING_FAIL,
      payload: message,
    });
  }
};

export const RGetSessionKonselingStatus = () => async (dispatch) => {
  dispatch({
    type: GET_SESSION_KONSELING_STATUS_RESET,
  });
};
export const GetSessionKonselingStatus = () => async (dispatch) => {
  const { token, typeUser, session } = UserDatPduliaDecode();
  try {
    dispatch({
      type: GET_SESSION_KONSELING_STATUS_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    };

    const { data: data } = await axios.get(
      API_GET_SESSION_KONSELING(session, typeUser),
      config
    );

    // let data = DUMMY_PDULI_SESSION_DATA_STAUTS;
    // console.log(
    //   "data send api pduli GetKonselingSession dummy",
    //   DUMMY_PDULI_SESSION_DATA_STAUTS
    // );

    let objTmp = {};
    objTmp.session = {
      date: data.data.session_date,
      startTime: data.data.start_time,
      duration: data.data.duration,
      status: data.data.status,
    };

    dispatch({
      type: GET_SESSION_KONSELING_STATUS_SUCCESS,
      payload: objTmp,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: GET_SESSION_KONSELING_STATUS_FAIL,
      payload: message,
    });
  }
};

export const ActivatedAlertTimeWillBeOver = (v) => async (dispatch) => {
  dispatch({
    type: PDULI_ALERT_TIME_WILL_BE_OVER,
    payload: v,
  });
};

export const RStopSessionKonseling = () => async (dispatch) => {
  dispatch({
    type: STOP_SESSION_KONSELING_RESET,
  });
};

export const StopSessionKonseling = (idServerRecord) => async (dispatch) => {
  try {
    dispatch({
      type: STOP_SESSION_KONSELING_REQUEST,
    });
    const { token, typeUser, session } = UserDatPduliaDecode();

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    };

    const { data: data } = await axios.get(
      API_STOP_SESSION_KONSELING(session, typeUser, idServerRecord),
      config
    );

    dispatch({
      type: STOP_SESSION_KONSELING_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: STOP_SESSION_KONSELING_FAIL,
      payload: message,
    });
  }
};
